import { Component, Input, OnInit } from '@angular/core';
import { QuestionType } from '@shared/enums/question.enum';
import { IAnswer } from '@shared/interfaces/answer.interface';
import { ISetting } from '@shared/interfaces/setting.interface';
import moment from 'moment';
import { Options } from '@angular-slider/ngx-slider';
import { SessionStorage } from 'ngx-webstorage';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-answers',
    templateUrl: './answers.component.html',
    standalone: false
})
export class AnswersComponent implements OnInit {
  @SessionStorage() public settings: ISetting;

  @Input() public title: string;
  @Input() public answers: IAnswer[] = [];
  @Input() public isEditable = Boolean(true);

  public openEditAnswerModal: Subject<any> = new Subject<any>();
  public questionType = QuestionType;

  public sliderOptions: Options = {
    floor: 0,
    ceil: 100,
    disabled: true
  };

  constructor() {}

  @Input() public afterSubmit: any = () => {};

  ngOnInit(): void {}

  public edit(a: IAnswer) {
    this.openEditAnswerModal.next(a);
  }

  public trackByFn(i: any) {
    return i;
  }

  public getFormattedDateRange(value: string, monthOnly = false): string {
    try {
      const dates = JSON.parse(value);
      if (Array.isArray(dates) && dates.length === 2) {
        const fmt = monthOnly ? 'MMM YYYY' : 'MMM D, YYYY';
        const startDate = moment(dates[0]).format(fmt);
        const endDate = moment(dates[1]).format(fmt);
        return `${startDate} - ${endDate}`;
      }
    } catch (e) {
      console.error('Invalid date range format:', value);
    }
    return value;
  }
}
